var $36119bbbf8e2af9b$exports = {};
$36119bbbf8e2af9b$exports = {
    "maximum": `Daugiausia`,
    "minimum": `Ma\u{17E}iausia`
};


export {$36119bbbf8e2af9b$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
